export default "__VITE_ASSET__BLmDkWpC__"